import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { HostService } from 'src/app/services/host.service';
import { AppService } from 'src/app/app.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Subscription } from 'rxjs';
import { RentingService } from 'src/app/services/renting.service';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { RentingMessageComponent } from 'src/app/shared/renting-message/renting-message.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-showcar',
  templateUrl: './showcar.component.html',
  styleUrls: ['./showcar.component.scss']
})
export class ShowcarComponent implements OnInit {
  //Subscription
  VehiculeSubscription: Subscription;
  changeStatusSubscription: Subscription;
  statusChanged: boolean;
  rentingGetted: boolean;

  imageVehicule :Array<object>=[];
  vehiculeId: any;
  public config: SwiperConfigInterface = { };
  public chefs:any[] = [];
  displayedColumns: string[] = ['dateStart', 'dateEnd', 'price', 'status', 'date', 'lodger', 'actions'];
  rentings: any;
  vehicule:any;
  dataSource!: MatTableDataSource<any>;
  public statuses = ['disponible','indisponible']

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  currency: string;

  constructor(
            private vehiculeService: VehiculeserviceService, 
            public router: Router,
            private activetedRoute: ActivatedRoute,
            private hostService : HostService,
            public appService:AppService,
            private rentingService: RentingService,
            private toastr: ToastrService,
            private spinner: NgxSpinnerService
            ) { }

  ngOnInit(): void {

    this.loadData();

    //this.chefs = this.appService.getChefs();

    this.currency = this.appService.getCurrency();
    
  }

  loadData()
  {
    this.vehiculeId = this.activetedRoute.snapshot.queryParamMap.get("vehicule");
     this.VehiculeSubscription=this.vehiculeService.showOneCar(this.vehiculeId).subscribe((res:any)=>{
        let images:Array<any> = res.data.image;
        images.forEach(elt=>{
          let objectDefine = {
            image: this.hostService.getHttpsImage()+'/'+elt.title_image,
            thumbImage:this.hostService.getHttpsImage()+'/'+elt.title_image,
            alt: 'alt of image'
          };  

          this.imageVehicule.push(objectDefine);
        });

        this.rentingGetted = false;
        this.vehicule= res.data;
        this.rentings = res.data.reservation;
        this.dataSource = new MatTableDataSource(res.data.reservation);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        
      },error=>{
        this.toastr.show("Une erreur s'est produite veillez contacter votre administrateur","Erreur Erreur",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "error"
        );
        // console.log(error);
      })
      this.statusChanged = false;
  }

  public changeStatus(idRenting: number, value: string) {
    let currentObject = this.rentings.find(
      (renting: any) => renting.id == idRenting
    );

    if (currentObject.renting_status != value) {
      let obj = {
        id: idRenting,
        status: value,
      };

      this.spinner.show();

      this.changeStatusSubscription = this.rentingService
        .changeStatus(obj)
        .subscribe((response: any) => {

          this.loadData();

          this.spinner.hide();
          
          this.toastr.show("Le status de la réservation du " + currentObject.renting_date_departure +" au " + currentObject.renting_date_return + " du véhicule a été modifié","Status Changé",
            {
              timeOut: 5000,
              closeButton: true,
            } as IndividualConfig,
            "toast-" + "success"
          );
        });
    } else {
      this.toastr.show("Impossible d'effectuer cette action","Erreur Erreur",
        {
          timeOut: 5000,
          closeButton: true,
        } as IndividualConfig,
        "toast-" + "error"
      );
    }
  }

  noterReservation(id:number)
  {
      let obj = {
        id: id,
      };

      this.spinner.show();

    this.rentingService.envoiMailCar(obj).subscribe(
      (data) => {
        console.log(data);
        this.changeStatus(id, "TERMINER");
        
        this.toastr.show("Un mail a été envoyé au client pour noter le service","mail envoyé",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "success"
        );
        this.spinner.hide();
      },
      (error) => {
        this.toastr.show("Le mail n'a pas été envoyé","Erreur Erreur",
          {
            timeOut: 5000,
            closeButton: true,
          } as IndividualConfig,
          "toast-" + "error"
        );
      }
    );
  }

  public viewRenting(idRenting: number) {

    let renting = this.rentings.find((res: any) => res.id == idRenting);
   
    let obj = {
      'idRenting': idRenting,
      'status': renting.renting_status,
      'message': renting.renting_message,
      'key': 'owner',
    }
    
		this.appService.openDialogGalsenMessage(RentingMessageComponent, obj, 'theme-dialog');
			 
  }

  public remove() {
    this.vehiculeService.suprimeCar(this.vehiculeId).subscribe((data) => {
       this.toastr.error("vehicule suprimé");
       this.router.navigate(["admin/vehicules"]);
    });
  }

  public list() {
    this.router.navigate(["admin/vehicules"]);
  }

  onChange($event: MatSlideToggleChange, id: number,data:any) {
     let obj = {
         vehicule_verify: $event.checked,
         id:id,
         status:data        
     }
     this.vehiculeService.updateCarSuper( obj).subscribe((data:any)=>{
      this.loadData();
      this.toastr.success('La validité du véhicule a été modifié avec succès');
     },error=>{
      this.toastr.error("Oops une erreur s'est produite, veillez contacter votre Administrateur");
     });
  }

  public onStatusSelectionChange(event:any , idcar:number, verification:number){  
    let obj ={
      vehicule_verify: verification,
      id:idcar,
      status:event.value
    }
  
    this.vehiculeService.updateCarSuper(obj).subscribe((data: any) => {
      this.loadData();
      this.toastr.success('La statut du véhicule a été modifié avec succès');
    },error=>{
      this.toastr.error("Oops une erreur s'est produite, veillez contacter votre Administrateur");
    });
  }


  ngOnDestroy(): void {
    if (this.rentingGetted) {
      this.VehiculeSubscription.unsubscribe();
    }

    if (this.statusChanged) {
      this.changeStatusSubscription.unsubscribe();
    }
  }

}